<template>
    <report-section
        :id="id"
        title="Overview"
        class="overview"
    >
        <table class="table overview is-striped">
            <tr>
                <th>
                    Coordinates:
                </th>
                <td>
                    <div>
                        {{ latitude | numFormat('0.000') }}° N,
                        {{ longitude | numFormat('0.000') }}° W
                    </div>
                </td>
            </tr>
            <tr>
                <th>
                    Watershed Area:
                </th>
                <td>{{ reportData.overview.area_km2 | numAutoFormat }} km²</td>
            </tr>
            <tr>
                <th>
                    Watershed Elevation:
                </th>
                <td>
                    <div>
                        {{ calculatedElevations.max | numAutoFormat }} m (max),
                        {{ calculatedElevations.mean | numAutoFormat }} m (mean),
                        {{ calculatedElevations.min | numAutoFormat }}  m (min)
                    </div>
                </td>
            </tr>
            <tr>
                <th>
                    Mean Annual Discharge:
                </th>
                <td>
                    {{ reportData.overview.mad_m3s | numAutoFormat }} m³/s
                </td>
            </tr>
            <tr>
                <th>
                    Watershed Order:
                </th>
                <td>
                    {{ reportData.overview.local_watershed_order }}
                </td>
            </tr>
        </table>
    </report-section>
</template>

<script>
import sectionMixin from '@foundryspatial/report-section/mixin';

export default {
    name: 'OverviewSection',

    mixins: [
        sectionMixin,
    ],

    computed: {
        latitude() {
            return this.reportData.lngLat.lat;
        },

        longitude() {
            return this.reportData.lngLat.lng;
        },

        calculatedElevations() {
            return {
                max: this.reportData.overview.max_elev,
                mean: this.reportData.overview.avg_elev,
                min: this.reportData.overview.min_elev,
            };
        },
    },
};
</script>

<style lang="scss">
</style>
